import type { IconProps } from '../types/IconProps.ts';
export const ChevronsUp: IconProps = {
    name: 'ChevronsUp',
    children: [
        `<path d="m7 11 4.65-4.65c.2-.2.5-.2.7 0L17 11M7 18l4.65-4.65c.2-.2.5-.2.7 0L17 18" />`,
    ]
};